// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#iframe-container[data-v-46b4c0de]{height:40rem}@media (min-width:640px){#iframe-container[data-v-46b4c0de]{height:36rem}}iframe[data-v-46b4c0de]{height:100%;width:100%}.close-button[data-v-46b4c0de]{position:absolute;top:0;right:0;border-width:1px;--tw-border-opacity:1;border-color:rgba(209,213,219,var(--tw-border-opacity));--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));width:32px;height:32px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
